import SDK from './core';

export const reportUserOrGroup = (jid, type, data) => SDK.reportUserOrGroup(jid, type, data);
export const updateUserSettings = data => SDK.updateUserSettings(data);
export const getUserSettings = () => SDK.getUserSettings();
export const updateMuteNotificationSettings = status => SDK.updateMuteNotificationSettings(status);
export const deleteMyAccount = (reason, feedback) => SDK.deleteMyAccount(reason, feedback);
export const sendFeedback = (title, description) => SDK.sendFeedback(title, description);
export const getAllArchivedChats = () => SDK.getAllArchivedChats();
export const getMediaMetadata = ({ file, mediaType, seekTime }) => SDK.getMediaMetadata({ file, mediaType, seekTime });
